import ApplicationSerializer from '@square/dashboard-data/serializers/application';
export default ApplicationSerializer.extend({
  primaryKey: 'fidelius_token',
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    return this._super(store, primaryModelClass, payload.bank_accounts, id, requestType);
  }
});